import React from 'react';

import {
  Button,
  Dialog, DialogActions, DialogContent, DialogTitle
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

import { withStyles } from '@mui/styles';
import ComponentWrapper from '../../../common/ComponentWrapper';

const styles = {
  dialog: {
    paddingBottom: '10px',
  },
  dialogTitle: {
    marginTop: '15px',
    textAlign: 'center',
    fontSize: 16,
    lineHeight: '10px',
  },
  closeModalIcon: {
    top: '10px',
    fontSize: 20,
    right: '10px',
    color: '#C4C4C4',
    transition: '.2s',
    position: 'absolute',
    '&:hover': {
      color: '#4E4C4C',
      cursor: 'pointer',
      transition: '.2s',
    },
  },
  // actionBtn: {
  //   margin: '10px',
  //   fontSize: 14,
  //   color: '#347CFF',
  //   //minHeight: '32px',
  //   padding: '5px 20px',
  //   borderRadius: '20px',
  //   textTransform: 'none',
  //   background: '#ffff',
  //   minWidth: '125px',
  // },
  actionBtnAccept: {
    color: '#E91818',
    '&:hover': {
    },
  }
};

class InterfaceDialog extends ComponentWrapper {
  state = {
    strategy: 0
  }

  render() {
    const { classes, interfaceDialogOpen, onClose, setConceptToInterfaceMode, is_interface } = this.props;

    return (
      <Dialog
        open={interfaceDialogOpen}
        onClose={onClose}
        aria-labelledby="interface-dialog-title"
      >
        <div style={{ height: '3px', background: '#347CFF' }}></div>

        <CloseIcon className={classes.closeModalIcon} onClick={() => onClose()} />
        {is_interface ?
          <DialogTitle className={classes.dialogTitle} id="val-dialog-title">
            Are you really want to switch this interface to Concept mode?
          </DialogTitle>
        : <DialogTitle className={classes.dialogTitle} id="val-dialog-title">
            Are you really want to switch this concept to Interface mode?
          </DialogTitle>}
          <DialogContent className={classes.dialog}>
            <span>
              Accepting this action might cause some global changes
            </span>
          </DialogContent>
          <DialogActions className={`${classes.alignJustifyCenter}`}>
            <Button
              className={`${classes.actionBtn} ${classes.mr20}`}
              onClick={onClose}
            >
              No, Cancel
            </Button>
            <Button
              className={`${classes.actionBtn} ${classes.actionBtnAccept}`}
              onClick={() => setConceptToInterfaceMode()}
            >
              Yes, Accept
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(InterfaceDialog);
